
import React from 'react';
import styled from 'styled-components';

import { RadioButtonGroup } from '../../../components/forms/RadioButton';
import { RegisteredTypes } from '../../../service/emailDomainService';
import UsernamePlusDomainEmailInput from './UsernamePlusDomainEmailInput';
import EmailDropdown from './EmailDropdown';
import Tooltip from '../../../components/tooltip';
import MessageDisplay, {
  MessageTypes,
  type Message,
} from '../styledComponent/MessageDisplay';

interface RegisteredEmailDomainInputProps {
  id: string;
  email: string;
  setEmail: (email: string) => void;
  domainList: string[];
  emailList: string[];
  registeredTypeValue: RegisteredTypes;
  setRegisteredTypeValue: (value: RegisteredTypes) => void;
  displayMessage?: Message;
}

const FlexDivWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const OuterWrapper = styled.div`
  margin-bottom: 10px;
`;

export const FIELDS = {
  DOMAIN: 'fromEmail.domain.domain',
  USERNAME: 'fromEmail.domain.username',
  EMAIL: 'fromEmail.email.email',
};

const RegisteredEmailDomainInput: React.FC<RegisteredEmailDomainInputProps> = ({
  id,
  email,
  setEmail,
  domainList = [],
  emailList = [],
  registeredTypeValue,
  setRegisteredTypeValue,
  displayMessage,
}) => {
  const handleRadioGroupChange = (value: RegisteredTypes) => {
    setRegisteredTypeValue(value);
  };

  const registeredTypeOptions = [
    {
      name: 'Domain',
      value: RegisteredTypes.DOMAIN,
    },
    {
      name: 'Email',
      value: RegisteredTypes.EMAIL_ADDRESS,
    },
  ];

  const styles = {
    wrapperStyles: [],
    optionStyles: ['inlineOption'],
  };

  const isUsernameError =
    FIELDS.USERNAME === displayMessage?.field &&
    MessageTypes.ERROR === displayMessage?.type;

  const isDomainError =
    FIELDS.DOMAIN === displayMessage?.field &&
    MessageTypes.ERROR === displayMessage?.type;

  const isEmailError =
    FIELDS.EMAIL === displayMessage?.field &&
    MessageTypes.ERROR === displayMessage?.type;

  const tipText =
    'Not seeing your email / domain? Please contact helpdesk@cirium.com ' +
    'to get your email registered so we can send on your behalf.';

  return (
    <>
      <OuterWrapper>
        <div>
          <RadioButtonGroup
            id={`${id}-registeredType-radioGroup`}
            options={registeredTypeOptions}
            value={registeredTypeValue}
            field="registeredType"
            onChange={handleRadioGroupChange}
            styles={styles}
          />
        </div>
        <FlexDivWrapper>
          {registeredTypeValue === RegisteredTypes.DOMAIN ? (
            <UsernamePlusDomainEmailInput
              id={`${id}-${UsernamePlusDomainEmailInput.name}`}
              email={email}
              setEmail={setEmail}
              domainList={domainList}
              isUsernameError={isUsernameError}
              isDomainError={isDomainError}
            />
          ) : (
            <EmailDropdown
              id={`${id}-${EmailDropdown.name}`}
              email={email}
              error={isEmailError}
              setEmail={setEmail}
              emailList={emailList}
            />
          )}
          <Tooltip id="fromEmailTooltip" tipText={tipText} />
          {displayMessage && (
            <MessageDisplay type={displayMessage.type}>
              {displayMessage.message}
            </MessageDisplay>
          )}
        </FlexDivWrapper>
      </OuterWrapper>
    </>
  );
};

export default RegisteredEmailDomainInput;
